import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils.js';
const buttonVariants = cva([
    'inline-flex items-center gap-1.5 whitespace-nowrap rounded-pill border-[0.5px] border-transparent',
    'font-ui text-sm font-medium leading-[1.4] tracking-[-0.005em] transition-colors',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
    'disabled:cursor-not-allowed disabled:opacity-45',
].join(' '), {
    variants: {
        variant: {
            primary: 'bg-accent text-white hover:bg-accent-strong',
            outline: 'border-line-strong bg-surface text-accent hover:border-accent',
            ghost: 'bg-transparent text-ink-3 hover:bg-surface-muted hover:text-ink',
            danger: 'bg-danger text-white hover:bg-danger-strong',
        },
        size: {
            md: 'px-[18px] py-[9px]',
            sm: 'px-[13px] py-1.5 text-[13px]',
        },
    },
    defaultVariants: {
        variant: 'primary',
        size: 'md',
    },
});
export const Button = forwardRef(({ className, variant = 'primary', size = 'md', type = 'button', ...props }, ref) => (_jsx("button", { ref: ref, type: type, "data-variant": variant ?? undefined, "data-size": size ?? undefined, className: cn(buttonVariants({ variant, size }), className), ...props })));
Button.displayName = 'Button';
//# sourceMappingURL=button.js.map